import ugr from '@/UGRoute';
import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Container,
  Divider,
  Input,
  InputGroup,
  Panel,
  Stack,
  Table,
  Checkbox,
  CheckPicker,
  Notification,
  IconButton,
  Modal,
  Button,
  Form,
  toaster,
  Message
} from 'rsuite';
import { Button as AntdBtn } from 'antd';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import { Link } from 'react-router-dom';
import VisibleIcon from '@rsuite/icons/Visible';
import FormControlLabel from 'rsuite/esm/FormControlLabel';
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

const { Column, HeaderCell, Cell } = Table;
const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div style={{ lineHeight: '46px' }}>
      <Checkbox
        value={rowData[dataKey]}
        inline
        onChange={onChange}
        checked={checkedKeys.some(item => item === rowData[dataKey])}
      />
    </div>
  </Cell>
);

const GreetingBuyer = () => {
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 290; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);

  // const [buyerdata, setBuyerdata] = useState([]);
  // useEffect(() => {
  //   fetchData2();
  // }, [buyerdata]);
  // const fetchData2 = async () => {
  //   const response = await fetch(`${globalIP}/api/buyer-details?populate=*`);
  //   const json = await response.json();
  //   setBuyerdata(json.data);
  // };
  // const [companydataa, setCompanydataa] = useState([]);
  // useEffect(() => {
  //   fetchData6();
  // }, [companydataa]);
  // const fetchData6 = async () => {
  //   try {
  //     const response = await fetch(`${globalIP}/api/buyer-companies`);
  //     const json = await response.json();
  //     // Extract unique company names using Set to eliminate duplicates
  //     const uniqueCompanyNames = new Set(json.data.map(item => item.attributes.companynm));
  //     // Convert Set back to an array of objects with label and value keys
  //     const processedData = Array.from(uniqueCompanyNames).map(companyName => ({
  //       label: companyName,
  //       value: companyName
  //     }));
  //     setCompanydataa(processedData);
  //   } catch (error) {
  //     console.error('Error fetching category data:', error);
  //   }
  // };

  const [buyerdata, setBuyerdata] = useState([]);
  useEffect(() => {
    fetchData2();
  }, []); // ✅ Empty array - sirf ek baar run hoga

  const fetchData2 = async () => {
    const response = await fetch(`${globalIP}/api/buyer-details?populate=*`);
    const json = await response.json();
    setBuyerdata(json.data);
  };

  // Company data - FIXED: empty dependency array  
  const [companydataa, setCompanydataa] = useState([]);
  useEffect(() => {
    fetchData6();
  }, []); // ✅ Empty array - sirf ek baar run hoga

  const fetchData6 = async () => {
    try {
      const response = await fetch(`${globalIP}/api/buyer-companies`);
      const json = await response.json();
      const uniqueCompanyNames = new Set(json.data.map(item => item.attributes.companynm));
      const processedData = Array.from(uniqueCompanyNames).map(companyName => ({
        label: companyName,
        value: companyName
      }));
      setCompanydataa(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  // Email wala effect bhi check karein
  useEffect(() => {
    if (selectedRowIds.length > 0) {
      fetchDatabemail();
    }
  }, [selectedRowIds]);

  const [selectedCompany, setSelectedCompany] = useState([]);
  const handleComapnyChange = value => {
    setSelectedCompany(value);
  };

  const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = value => {
    setSearchQuery(value);
  };
  const [isCartOpen, setIsCartOpen1] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const handleCartClose = () => {
    setIsCartOpen1(false);
  };
  const handleCheckboxChange = (rowId, checked) => {
    if (checked) {
      setSelectedRowIds(prevSelectedRowIds => [...prevSelectedRowIds, rowId]);
    } else {
      setSelectedRowIds(prevSelectedRowIds =>
        prevSelectedRowIds.filter(selectedRowId => selectedRowId !== rowId)
      );
    }
  };
  const handleCheckAll = (value, checked) => {
    if (checked) {
      // Select all items
      setSelectedRowIds(buyerdata.map(row => row.id));
    } else {
      // Deselect all items
      setSelectedRowIds([]);
    }
  };

  const [openEmail, setOpenEmail] = useState(false);
  const handleOpenEmail = () => setOpenEmail(true);
  const handleCloseEmail = () => setOpenEmail(false);
  /// Email system start
  const [to, setTo] = useState([]);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileContent, setFileContent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedRowIds) {
      fetchDatabemail();
    }
  }, [selectedRowIds]);
  // const fetchDatabemail = async () => {
  //   const excludeProductCodesFilter = selectedRowIds
  //     .map(code => `filters[id][$eq]=${code}`)
  //     .join('&');
  //   const apiUrl = `${globalIP}/api/buyer-details?populate=*&${excludeProductCodesFilter}`;
  //   const response = await fetch(apiUrl);
  //   const json = await response.json();
  //   const emails = json.data.flatMap(buyerDetail => buyerDetail.attributes.email);
  //   setTo(emails);
  // };

  const fetchDatabemail = async () => {
    const excludeProductCodesFilter = selectedRowIds
      .map(code => `filters[id][$eq]=${code}`)
      .join('&');
    const apiUrl = `${globalIP}/api/buyer-details?populate=*&${excludeProductCodesFilter}`;
    const response = await fetch(apiUrl);
    const json = await response.json();

    // Extract valid emails only
    const emails = json.data
      .map(buyerDetail => buyerDetail.attributes.email)
      .filter(email => email && email.trim() !== ''); // Filter out empty/null emails

    setTo(emails);
  };

  const handleFileChange = async event => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFileName(selectedFile.name);
      const base64 = await convertFileToBase64(selectedFile);
      setFileContent(base64);
    }
  };
  const handleUploadChange = async file => {
    if (file) {
      setFileName(file.name); // store file name
      const base64 = await convertFileToBase64(file); // convert to Base64
      setFileContent(base64);
    }
  };
  // Function to convert file to Base64
  const convertFileToBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]); // Extract base64 content
      reader.onerror = error => reject(error);
    });
  };

  // const sendemail = async () => {
  //   const endpoint = `${globalIP}/api/email`;
  //   try {
  //     setLoading(true);
  //     for (const recipient of to) {
  //       const data = {
  //         to: recipient,
  //         subject: subject,
  //         html: message,
  //         attachments: fileContent
  //           ? [
  //               {
  //                 filename: fileName,
  //                 content: fileContent,
  //                 encoding: 'base64'
  //               }
  //             ]
  //           : []
  //       };
  //       const response = await fetch(endpoint, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(data)
  //       });
  //       setLoading(false); // Reset loading state, whether success or failure
  //       handleCloseEmail();
  //       if (response.ok) {
  //         console.log(`Email sent successfully to ${recipient}`);
  //       } else {
  //         console.error(`Failed to send email to ${recipient}`);
  //       }
  //     }
  //     // Notify user after all emails have been sent
  //     console.log('All emails sent successfully!');
  //     toaster.push(
  //       <Message showIcon type="success">
  //         All emails sent successfully!
  //       </Message>,
  //       { placement: 'topEnd' }
  //     );
  //   } catch (error) {
  //     console.error('Error:', error);
  //     toaster.push(
  //       <Message showIcon type="error">
  //         Failed to send email
  //       </Message>,
  //       { placement: 'topEnd' }
  //     );
  //   }
  // };
  const sendemail = async () => {
    const endpoint = `${globalIP}/api/send-mail`;

    // Prepare attachments array with actual base64 content
    const attachments = [];
    if (fileName && fileContent) {
      attachments.push({
        filename: fileName || '',
        contentType: 'application/octet-stream',
        base64: fileContent
      });
    }

    try {
      setLoading(true);

      // Har email ke liye alag API call
      const emailPromises = to.map(async (recipient) => {
        const data = {
          toEmail: recipient, // Single email bhej rahe hain
          subject: subject,
          message: message,
          attachments: attachments
        };

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        return response;
      });

      // Sabhi emails ke responses wait karein
      const responses = await Promise.all(emailPromises);

      // Check karein sabhi responses successful hain ya nahi
      const allSuccessful = responses.every(response => response.ok);
      const successfulCount = responses.filter(response => response.ok).length;
      const failedCount = responses.length - successfulCount;

      setLoading(false);
      handleCloseEmail();

      if (allSuccessful) {
        setSubject('')
        setMessage('')
        setFileName('')
        setFileContent('')
        toaster.push(
          <Message showIcon type="success">
            All {successfulCount} emails sent successfully!
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        toaster.push(
          <Message showIcon type="warning">
            {successfulCount} emails sent successfully, {failedCount} failed!
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      toaster.push(
        <Message showIcon type="error">
          Error sending emails
        </Message>,
        { placement: 'topEnd' }
      );
    }
  };
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar " justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Greetings</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Greetings</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5}>
              <CheckPicker
                data={companydataa}
                placeholder="Buyer Company Name"
                labelKey="label"
                value={selectedCompany}
                onChange={handleComapnyChange}
                valueKey="value"
                size="md"
                appearance="default"
                className="mng-market"
              />
            </Stack>
          </Stack>

          <Stack direction="column" alignItems="flex-end" spacing={24}>
            <Stack spacing={5}>
              <InputGroup inside>
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
            </Stack>
          </Stack>
        </Stack>
        <Divider style={{ marginTop: 0, marginBottom: 0 }} />
        <Panel>
          <Table
            height={tableHeight}
            data={buyerdata.filter(item => {
              const companynamem = item.attributes.companynm.toLowerCase();
              const byuernamem = item.attributes.buyernm.toLowerCase();
              const ContNo = item.attributes.contactno.toLowerCase();
              const email = item.attributes.email.toLowerCase();
              const country = item.attributes.country.toLowerCase();

              const camponyname = item.attributes.companynm;
              const categoryMatch =
                selectedCompany.length === 0 || selectedCompany.includes(camponyname);

              return (
                (companynamem.includes(searchQuery.toLowerCase()) ||
                  byuernamem.includes(searchQuery.toLowerCase()) ||
                  ContNo.includes(searchQuery.toLowerCase()) ||
                  email.includes(searchQuery.toLowerCase()) ||
                  country.includes(searchQuery.toLowerCase())) &&
                categoryMatch
              );
            })}
            rowHeight={60}
            rowKey="id"
            bordered
            cellBordered
          >
            <Column width={100}>
              <HeaderCell style={{ padding: 0 }}>
                <div style={{ lineHeight: '40px' }}>
                  <Checkbox
                    inline
                    checked={selectedRowIds.length === buyerdata.length}
                    indeterminate={
                      selectedRowIds.length > 0 && selectedRowIds.length < buyerdata.length
                    }
                    onChange={handleCheckAll}
                  />
                </div>
              </HeaderCell>
              <CheckCell
                dataKey="id"
                checkedKeys={selectedRowIds}
                onChange={(rowId, checked) => handleCheckboxChange(rowId, checked)}
                rowData={undefined}
              />
            </Column>

            <Column width={160}>
              <HeaderCell>
                <b>Buyer Company Name</b>
              </HeaderCell>
              <Cell dataKey={'attributes.companynm'} />
            </Column>
            <Column width={160}>
              <HeaderCell>
                <b>Buyer Name</b>
              </HeaderCell>
              <Cell dataKey={'attributes.buyernm'} />
            </Column>
            <Column width={160}>
              <HeaderCell>
                <b>Country</b>
              </HeaderCell>
              <Cell dataKey={'attributes.country'} />
            </Column>
            <Column width={160}>
              <HeaderCell>
                <b>Email</b>
              </HeaderCell>
              <Cell dataKey={'attributes.email'} />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>
                <b>Address</b>
              </HeaderCell>
              <Cell dataKey={'attributes.address'} />
            </Column>
            <Column width={160}>
              <HeaderCell>
                <b>Contact No.</b>
              </HeaderCell>
              <Cell dataKey={'attributes.contactno'} />
            </Column>
          </Table>
        </Panel>
        {selectedRowIds.length > 0 && (
          <Notification
            type="success"
            onClose={handleCartClose}
            style={{
              position: 'fixed',
              top: '80%',
              right: 20,
              transform: 'translateY(-50%)',
              zIndex: 9999,
              background: '#0070a9',
              color: 'white'
            }}
            className="view"
          >
            <b style={{ color: 'white' }}>Selected Buyers: {selectedRowIds.length}</b>
            <Divider />
            <IconButton icon={<VisibleIcon />} onClick={handleOpenEmail}>
              <b>E-mail</b>
            </IconButton>
          </Notification>
        )}
        <Modal open={openEmail} onClose={handleCloseEmail} backdrop="static">
          <Modal.Header>
            <Modal.Title>
              <b>Email</b>{' '}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ justifyContent: 'center' }}>
            <Panel style={{ width: '60%', margin: 'auto' }}>
              <Form>
                {/* <FormControlLabel>To:</FormControlLabel>
                <Input value={to} onChange={value => setTo(value)} /> */}
                <FormControlLabel>To:</FormControlLabel>
                <Input
                  value={Array.isArray(to) ? to.join(', ') : to}
                  onChange={value => {
                    // Convert string back to array when editing
                    const emailArray = value.split(',').map(email => email.trim()).filter(email => email);
                    setTo(emailArray);
                  }}
                />
                <FormControlLabel>Subject</FormControlLabel>
                <Input value={subject} onChange={value => setSubject(value)} />
                <FormControlLabel>Body</FormControlLabel>
                <Form.Control
                  rows={5}
                  name="textarea"
                  accepter={Textarea}
                  value={message}
                  onChange={value => setMessage(value)}
                />
                {/* <input type="file" style={{ opacity: 1 }} onChange={handleFileChange} /> */}
                <FormControlLabel>Attachment</FormControlLabel><br/>
                <Upload
                  beforeUpload={file => {
                    handleUploadChange(file); // call our custom handler
                    return false; // prevent automatic upload
                  }}
                  onRemove={() => {
                    setFileName(null);
                    setFileContent(null);
                  }}
                  fileList={fileName ? [{ name: fileName }] : []}
                >
                  <AntdBtn icon={<UploadOutlined />}>Select File</AntdBtn>
                </Upload>
              </Form>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseEmail} appearance="subtle" active>
              Cancel
            </Button>
            <Button onClick={sendemail} appearance="primary" color="cyan" loading={loading}>
              Send
            </Button>
          </Modal.Footer>
        </Modal>
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default GreetingBuyer;
